import { httpClient } from '../http-client'

export type StudyEventsFilters = {
  mentorId: string
  profileId: string
}

export type StudyEventPayload = {
  mentor_id: string
  profile_id?: string | null
  startDate: string
  endDate: string
  title: string
  description?: string
  productData?: Record<string, any>
  variant?: string
  event_type?: string
}

export type StudyEventResponse = {
  id: string
  title: string
  startDate: string
  endDate: string
  type: 'study' | 'meeting'
  mentor_id: string
  profile_id: string
  productData?: Record<string, any>
  variant?: string
  event_type?: string
}

export type AvailabilityPayload = {
  mentor_id: string
  profile_id?: string | null
  start_at: string
  end_at: string
}

export type AvailabilityResponse = {
  id: string
  mentor_id: string
  profile_id: string
  start_at: string
  end_at: string
  created_at?: string
}

class StudyService {
  async getEvents({ mentorId, profileId }: StudyEventsFilters): Promise<StudyEventResponse[]> {
    const response = await httpClient.get(`/client-study/event/${mentorId}/${profileId}`)
    return response.data
  }

  async createEvent(payload: StudyEventPayload): Promise<StudyEventResponse> {
    const { mentor_id, profile_id, ...eventData } = payload
    const response = await httpClient.post(`/client-study/event/${mentor_id}/${profile_id || mentor_id}`, eventData)
    return response.data
  }

  async updateEvent(eventId: string, payload: StudyEventPayload): Promise<StudyEventResponse> {
    const { mentor_id, profile_id, ...eventData } = payload
    const response = await httpClient.put(`/client-study/event/${mentor_id}/${profile_id || mentor_id}/${eventId}`, eventData)
    return response.data
  }

  async deleteEvent(eventId: string): Promise<void> {
    await httpClient.delete(`/client-study/event/${eventId}`)
  }

  async getAvailability({ mentorId, profileId }: StudyEventsFilters): Promise<AvailabilityResponse[]> {
    const response = await httpClient.get(`/client-study/availability/${mentorId}/${profileId}`)
    return response.data
  }

  async createAvailability(payload: AvailabilityPayload): Promise<AvailabilityResponse> {
    const { mentor_id, profile_id, ...availabilityData } = payload
    const response = await httpClient.post(`/client-study/availability/${mentor_id}/${profile_id || mentor_id}`, availabilityData)
    return response.data
  }

  async deleteAvailability(availabilityId: string): Promise<void> {
    await httpClient.delete(`/client-study/availability/${availabilityId}`)
  }
}

export const studyService = new StudyService()

